import React from 'react';
import { Badge } from '../ui/badge';
import { X } from '@phosphor-icons/react';
import BillableBadge from './BillableBadge';

const SelectedCodeDisplay = ({ value, description, onClear, testId }) => (
  <div
    className="flex items-center gap-2 p-2.5 border rounded-md bg-slate-50"
    data-testid={`${testId}-selected`}
  >
    <Badge
      variant="outline"
      className="font-mono bg-indigo-50 text-indigo-700 border-indigo-200"
    >
      {value}
    </Badge>
    <span className="text-sm text-slate-600 flex-1 truncate">{description}</span>
    <BillableBadge code={value} />
    <button
      type="button"
      onClick={onClear}
      className="p-1 hover:bg-slate-200 rounded transition-colors"
      data-testid={`${testId}-clear`}
    >
      <X size={14} className="text-slate-400" />
    </button>
  </div>
);

export default SelectedCodeDisplay;
